import React from 'react';

const SvgSelfServiceOut: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="-4 -4 24 24" fill="none" {...props}>
    <mask
      id="mask0_2501_50398"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
    >
      <path d="M0 0H16V16H0V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_2501_50398)">
      <path
        d="M9.99126 1.87921C9.991 1.53909 9.71427 1.2624 9.37445 1.2624H1.87921C1.53891 1.26266 1.26266 1.53891 1.2624
        1.87921V10.3737C1.26238 10.4545 1.27886 10.5344 1.30969 10.6091C1.34064 10.6839 1.3861 10.7522 1.44333 10.8096C1.50062
        10.8669 1.56892 10.9122 1.64379 10.9432C1.7185 10.9742 1.79835 10.9904 1.87921 10.9905H4.36906C4.37214 10.9904 4.37522
        10.9895 4.37831 10.9895C4.38159 10.9895 4.38531 10.9904 4.38859 10.9905H9.37343C9.71445 10.9905 9.99126 10.714 9.99126
        10.3727V1.87921ZM5.01054 14.7376H6.24415V12.2539H5.01054V14.7376ZM11.2547 10.3727C11.2547 11.4124 10.4114 12.2539
        9.37343 12.2539H7.50758V14.7376H9.37445L9.50193 14.7499C9.78983 14.8088 10.0067 15.0635 10.0067 15.3688C10.0067
        15.6741 9.78983 15.9288 9.50193 15.9877L9.37445 16H1.87921C1.5306 15.9997 1.24801 15.7175 1.24801 15.3688C1.24801
        15.0201 1.5306 14.7379 1.87921 14.7376H3.74711V12.2539H1.87921C1.63234 12.2539 1.38766 12.2055 1.1596 12.111C0.93153
        12.0165 0.724519 11.8775 0.549987 11.7029C0.375384 11.5282 0.236257 11.3206 0.141866 11.0923C0.071066 10.921 0.02618
        10.7404 0.00822411 10.5567L0 10.3727V1.87921C0.000257825 0.841249 0.841249 0.000258096 1.87921 0H9.37445C10.4112 0
        11.2544 0.840743 11.2547 1.87921V10.3727Z"
        fill="#373B40"
      />
      <path
        d="M12.8913 3.41712C13.0712 3.23725 13.349 3.21435 13.5533 3.34927L13.6356 3.41712L16.1131 5.89463L13.6356 8.37214C13.43
       8.57769 13.0968 8.57769 12.8913 8.37214C12.6857 8.16659 12.6857 7.83341 12.8913 7.62786L14.0982 6.42097H8C7.70931
       6.42097 7.47366 6.18532 7.47366 5.89463C7.47366 5.60394 7.70931 5.36828 8 5.36828H14.0982L12.8913 4.1614L12.8234
       4.07916C12.6885 3.87485 12.7114 3.59698 12.8913 3.41712Z"
        fill="#373B40"
      />
    </g>
  </svg>
);

export default SvgSelfServiceOut;
